export const PRODUCT = 'LoginViaInter'
export const INTER_ID_ACESSO = 'INTER_ID_ACESSO'
export const INTER_ID_FLUXO = 'INTER_ID_FLUXO'

export const SCREEN_NAMES = {
  LANDING_PAGE: ':LandingPage',
  AUTHORIZATION: ':Autorizacao',
  TOKEN: ':Token',
  SUCCESS: ':Sucesso',
  CONNECTIONS: ':Conexoes',
}
